import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL, IMpTableDto } from '@/dtos';

import formatTableOptionTitle from './formatTableOptionTitle';

export const QUERY_KEY = 'GET_MP_TABLES';

const useMpTablesQuery = () => {
  const { data, isLoading } = useQuery([QUERY_KEY], () => api.get<IMpTableDto[]>(API_URL.MP_TABLES));

  const options = useMemo<Option[]>(() => {
    const list = data?.data || [];
    return list.map((item) => ({
      key: toString(item.id),
      value: toString(item.id),
      title: formatTableOptionTitle(item.name, item.identifier),
    }));
  }, [data]);

  return {
    options,
    isLoading,
  };
};

export default useMpTablesQuery;
